import { render, staticRenderFns } from "./CarouselSelector.vue?vue&type=template&id=ada16946&"
import script from "./CarouselSelector.vue?vue&type=script&lang=js&"
export * from "./CarouselSelector.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports